import React, { PropsWithChildren, ReactNode } from 'react';
import { LinkProps } from '../../../../types/HtmlProps';
import { Hyperlink } from '../../../../components/atoms/Hyperlink';

export type ContextMenuLinkProps = PropsWithChildren<LinkProps & { routing?: boolean }>;

export function ContextMenuLink(props: ContextMenuLinkProps): ReactNode {
  return props.href ? (
    <Hyperlink {...props} to={props.href} routing={props.routing} className="context-menu__button font-regular-15-21">
      {props.children}
    </Hyperlink>
  ) : null;
}
